// local PHP backend
// const BASE_URL = 'http://localhost:8000'; 

// production PHP backend
const BASE_URL = 'https://vasmigroup.com';

// Expenses API
export const EXPENSES_API_URL = 'http://192.168.88.14:8097';

export default BASE_URL;